import { getIsInternalUserFromStorage } from "./storageUtils";

class UserUtils {
  abbreviateUsername(name: unknown) {
    if (typeof name != "string" || name.length === 0) {
      return "";
    }

    const userNames = name
      .trim()
      .split(" ")
      .map((item) => item.trim())
      .filter((item) => item !== "");

    if (userNames.length <= 2) {
      return userNames.join(" ");
    }

    const firstName = userNames[0];
    const middleNames = userNames.slice(1, userNames.length - 1);
    const lastName = userNames[userNames.length - 1];

    const abbreviatedMiddleNames = middleNames.map((item) =>
      item.length > 3 ? `${item[0].toUpperCase()}.` : item
    );

    return `${firstName} ${abbreviatedMiddleNames.join(" ")} ${lastName}`;
  }

  getUserInitials(name: unknown) {
    if (typeof name != "string" || name.length === 0) {
      return "";
    }

    return name.trim().substring(0, 2);
  }

  isInternalUser() {
    const isInternalUser = getIsInternalUserFromStorage();
    return isInternalUser;
  }
}

const userUtils = new UserUtils();
export default userUtils;
